export enum Products {
  EmployeeChecking = "117",
  EmployeeSavings = "400"
}
